export const CRM_EVENTS_BLACKLIST = ['Portal invite sent', 'createCase', 'recommend general insurance product']
export const CP_EVENTS_BLACKLIST = [
  'Dashboard landing',
  'Enter documents section',
  'Create mandate clicked',
  'Schedule event',
  'Enter survey flow',
  'Schedule meeting',
  'HC section click settlingIn',
]
export const INTRODUCER_EVENTS_BLACKLIST = []

export const EVENTS_BLACKLIST = new Set([
  ...CRM_EVENTS_BLACKLIST,
  ...CP_EVENTS_BLACKLIST,
  ...INTRODUCER_EVENTS_BLACKLIST,
])

export const isEventBlacklisted = (eventName: string) => {
  return EVENTS_BLACKLIST.has(eventName)
}
